import { Injectable } from '@angular/core';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { ScaleRelativeToCenterComponent } from './ScaleRelativeToCenterComponent';
import { Circle } from '../object3D';

declare let THREE: any;

@Injectable()
export class CircleScaleComponent extends ScaleRelativeToCenterComponent<Circle> {

  constructor(
    drawings: DrawingsHolderService,
    positionCalculator: PositionCalculatorService
  ) {
    super(Circle, drawings, positionCalculator);
  }

  protected getNewSize(newSize, oldSize): any {
    const newWidth = Math.abs(newSize.x) || oldSize.x;
    const newHeight = Math.abs(newSize.z) || oldSize.z;
    return new THREE.Vector3(newWidth, 0, newHeight);
  }

  protected getObjectSize(object: Circle, result): void {
    result.copy(object.getSize()).divideScalar(2);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/CircleScaleComponent.ts